<template>
  <tr
    :key="product.productCode"
    class="c-product-variants-table__row"
    :class="oddEvenClass"
  >
    <td>
      {{ product.longDescription }}
    </td>

    <td v-if="isVisible.segment">
      <div class="d-flex align-items-center">
        <img
          :src="`${product.segmentationImageUrl}`"
          :alt="product.productCode"
        />

        <product-variants-table-tooltip
          :tooltip-text="product.segmentationDescription"
          :tooltip-image="product.segmentationImageUrlTooltip"
          :tooltip-image-alt="product.longDescription"
        />
      </div>
    </td>

    <td v-if="isVisible.safetyType">
      <product-variants-table-badge variant="outlined">
        {{ product.safetyType }}
      </product-variants-table-badge>
    </td>

    <td v-if="isVisible.weight" class="text-right">
      {{ product.weight }}
    </td>

    <td v-if="isVisible.priceEach" class="text-right">
      {{ priceData.priceEach | currency }}
    </td>

    <td v-if="isVisible.discount" class="text-right">
      {{ priceData.discount | percentage }}
    </td>

    <td v-if="isVisible.quantity">
      <span v-if="priceData.quantity === undefined">-</span>
      <LoadingOverlay v-else v-slot="{ startLoading }">
        <quantity-input
          :quantity="priceData.quantity"
          @change="quantity => startLoading(() => setQuantity(quantity))"
        />
      </LoadingOverlay>
    </td>

    <td v-if="isVisible.subtotal" class="text-right">
      {{ priceData.subtotal | currency }}
    </td>

    <td v-if="isVisible.deliveryDate" class="text-right">
      {{ priceData.delivery.date | date }}
      <div v-if="priceData.delivery.message">
        {{ priceData.delivery.message }}
      </div>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import LoadingOverlay from '@modules/components/loading-overlay.vue';
import ProductVariantsTableBadge from './product-variants-table-badge.vue';
import ProductVariantsTableTooltip from './product-variants-table-tooltip.vue';
import QuantityInput from '../../components/quantity-input.vue';

export default {
  name: 'ProductVariantsTableRow',
  components: {
    LoadingOverlay,
    ProductVariantsTableBadge,
    ProductVariantsTableTooltip,
    QuantityInput
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    oddEvenClass: {
      type: String,
      default: 'odd'
    }
  },
  computed: {
    ...mapGetters('webshop', ['isVisible']),
    ...mapState('webshop', ['baseShapePriceData']),
    priceData() {
      const product = this.baseShapePriceData.products?.find(
        x => x.productCode === this.product.productCode
      );
      if (!product) {
        return {
          delivery: {}
        };
      }
      return product;
    }
  },
  methods: {
    ...mapActions('webshop', ['getBaseShapePriceData']),
    async setQuantity(quantity) {
      await this.getBaseShapePriceData({
        productCode: this.product.productCode,
        productUrl: window.location.href,
        quantity
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.c-product-variants-table {
  &__row {
    &.even {
      &:nth-child(even) {
        background-color: $grey-100;
      }
    }

    &.odd {
      &:nth-child(odd) {
        background-color: $grey-100;
      }
    }

    td {
      border-bottom: 1px solid $light;
      min-height: 70px;
      white-space: nowrap;
      vertical-align: middle;

      padding: {
        top: 15px;
        left: 20px;
        bottom: 15px;
        right: 20px;
      }

      @include media-breakpoint-down(md) {
        padding: 15px;
      }
    }
  }
}
</style>
